import React from 'react';
import '../Pages/Reservation.css';

const ReservationList = ({ reservations, user, openEditModal, handleDeleteReservation, openQrModal }) => {
    const handleCancel = (reservationId, reservationStart) => {
        const now = new Date();
        const start = reservationStart.toDate();
        const hoursUntilStart = Math.max((start - now) / (1000 * 60 * 60), 0);
        
        if (hoursUntilStart < 12) {
            if (window.confirm(`Vas a cancelar la reserva. Se te cobrará una penalización de 1 coin por cada hora de reserva. ¿Deseas continuar?`)) {
                handleDeleteReservation(reservationId, hoursUntilStart);
            }
        } else {
            if (window.confirm('¿Estás seguro de que quieres cancelar esta reserva?')) {
                handleDeleteReservation(reservationId, hoursUntilStart);
            }
        }
    };

    return (
        <div className='reservation-reservas-container'>
            {reservations
                .filter(reservation => reservation.userId === user.uid && reservation.end.toDate() > new Date())
                .map(reservation => (
                    <div key={reservation.id} className="reservation-reservation">
                        <p>
                            <strong>{reservation.location}</strong><br />
                            Lugar: {reservation.placeName}<br />
                            Desde: {new Date(reservation.start.toDate()).toLocaleString()}<br />
                            Hasta: {new Date(reservation.end.toDate()).toLocaleString()}
                        </p>
                        <div>
                            <button className="reservation-btn-edit" onClick={() => openEditModal(reservation)}>Editar</button>
                            <button className="reservation-btn-delete" onClick={() => handleCancel(reservation.id, reservation.start)}>Cancelar</button>
                            <button className="reservation-btn-edit" onClick={() => openQrModal(reservation)}>Mostrar QR</button>
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default ReservationList;
